import React from 'react';

export const HR = ({ className = '' }) => {
  return <div className={`w-full h-px bg-gray-200 ${className}`} />;
};
